import * as crypto from 'crypto-js'

import { ITableHeader } from '@base/@types/components/Layout/TableGrid'

export const encrypteHeaderStorange = (key: string, header: any[]) => {
  if (!localStorage.getItem(key)) {
    localStorage.setItem(
      key,
      crypto.AES.encrypt(JSON.stringify(header), 'CHAVE').toString()
    )
  }
}

export const decrypterHeaderStorange = (key: string) => {
  let newHeaders: ITableHeader[] = []

  if (localStorage.getItem(key)) {
    try {
      const dec = crypto.AES.decrypt(
        localStorage.getItem(key),
        'CHAVE'
      ).toString(crypto.enc.Utf8)
      newHeaders = JSON.parse(dec.toString() || '')
      return newHeaders
    } catch {
      // Configuração corrompida: quem chama cai no header padrão.
      return undefined
    }
  }
}

/**
 * Mescla a visibilidade (`show`) de uma configuração salva sobre os headers
 * padrão, casando por grupo e por id de coluna.
 *
 * O array gravado em disco é posicional: mesclar por índice quebra a
 * configuração de todo mundo sempre que uma coluna é adicionada ou removida do
 * header padrão.
 */
export const mergeStoredHeaders = (
  base: ITableHeader[],
  stored?: ITableHeader[] | null
): ITableHeader[] => {
  if (!Array.isArray(stored) || stored.length === 0) return base

  return base.map(group => {
    const storedGroup = stored.find(item => item.group === group.group)

    return {
      ...group,
      columns: group.columns?.map(col => {
        const storedCol = storedGroup?.columns?.find(item => item.id === col.id)

        if (!storedCol) return { ...col }

        return {
          ...col,
          show: !!storedCol.show,
          notShowColumn: !!storedCol.notShowColumn
        }
      })
    }
  })
}
